import React, { FunctionComponent } from 'react';
import { IPType } from '../../../Configure/DIAConfig/types/ip';
import { getIPTypeLabel } from 'Quotes/QuoteBuilder/utils/ip';
import { currencyFormatter } from 'shared/utils/currencyFormatter';
import { IAEndLocation } from 'Quotes/types/store';
import { displayAnnualAmount } from 'Quotes/utils/priceDisplay';

interface IPChargeProps {
  ipType?: IPType;
  isManagedDIA: boolean;
  diaIPAllocation: IAEndLocation['dia_ip_allocation'];
  ipCost: number;
  viewAsMonthly: boolean;
}

const IPCharge: FunctionComponent<IPChargeProps> = ({
  ipType,
  isManagedDIA,
  diaIPAllocation,
  ipCost,
  viewAsMonthly,
}) => {
  if (!ipType) return null;
  return (
    <div className="price-summary__segment-wrapper">
      <div className="segment_label pl-2">
        <small>
          Includes {getIPTypeLabel(ipType, isManagedDIA, diaIPAllocation)} at{' '}
          {currencyFormatter.format(displayAnnualAmount(ipCost, viewAsMonthly) ?? 0)} per{' '}
          {viewAsMonthly ? 'month' : 'year'}
        </small>
      </div>
    </div>
  );
};

export default IPCharge;
